import { computed } from 'vue'
import { useAuth } from './useAuth.js'
import { useFrontendEnvironment } from '../services/FrontendEnvironment'

export function useOrchestratorBaseUrl() {
  const { tenantId: authTenantId, getAuthHeaders } = useAuth()
  const environment = useFrontendEnvironment()
  const orchestratorBaseUrl = computed(() => {
    // Use environment variable if set
    const envUrl = environment.getEnvVar('VUE_APP_ORCHESTRATOR_URL')
    if (envUrl) {
      return envUrl
    }
    const hostname = environment.getHostname()
    // Use proxy for localhost (configured in vue.config.js with /_proxy/ prefix)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return '/_proxy/orchestrator'
    }
    if (hostname.includes('staging')) {
      return 'https://staging-api.beads.j2clark.info'
    }
    return 'https://api.86proof.ai'
  })

  // Tenant ID — from JWT claim, fallback to 'local' for unauthenticated state.
  const tenantId = computed(() => authTenantId.value || 'local')

  // API headers — auth headers from JWT + API key if configured.
  // x-tenant-id comes from getAuthHeaders() when authenticated, fallback to tenantId for pre-auth state.
  const apiHeaders = computed(() => {
    const authHeaders = getAuthHeaders()
    const headers = Object.keys(authHeaders).length > 0
      ? { ...authHeaders }
      : { 'x-tenant-id': tenantId.value }
    const key = environment.getEnvVar('VUE_APP_API_KEY')
    if (key) headers['x-api-key'] = key
    return headers
  })

  /**
   * Build a scoped run URL: /jobs/{workspaceId}/{jobId}
   * @param {string} workspaceId
   * @param {string} jobId
   */
  function jobUrl(workspaceId, jobId) {
    return `${orchestratorBaseUrl.value}/jobs/${workspaceId}/${jobId}`
  }

  return { orchestratorBaseUrl, apiHeaders, tenantId, jobUrl }
}
